import { render, staticRenderFns } from "./GlobalParams.vue?vue&type=template&id=41ad76f7&scoped=true"
import script from "./GlobalParams.vue?vue&type=script&lang=js"
export * from "./GlobalParams.vue?vue&type=script&lang=js"
import style0 from "./GlobalParams.vue?vue&type=style&index=0&id=41ad76f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ad76f7",
  null
  
)

export default component.exports